import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './rental-menu/home/home.component';
import { VendorRegistrationComponent } from './rental-menu/vendor-registration/vendor-registration.component';
import { RentalMenuComponent } from './rental-menu/rental-menu.component';
import { VendorLoginComponent } from './rental-menu/vendor-login/vendor-login.component';
import { RentOnlineComponent } from './rental-menu/vendor-login/rent-online/rent-online.component';
import { MarketMapComponent } from './rental-menu/market-map/market-map.component';
import { NewsComponent } from './rental-menu/news/news.component';
import { ContactUsComponent } from './rental-menu/contact-us/contact-us.component';
import { VendorPaymentsComponent } from './Shared/vendor-Payment-details/vendor-payments.component';
import { RentalConfirmationComponent } from './rental-menu/vendor-login/rent-online/rental-confirmation/rental-confirmation.component';
import { AuthGuard } from './auth/auth.guard';
import { NewVendorRentonlineComponent } from './rental-menu/vendor-login/rent-online/new-vendor-rentonline/new-vendor-rentonline.component';
import { VendorApplicationComponent } from './rental-menu/vendor-application/vendor-application.component';
import { PageNotFoundComponent } from './rental-menu/page-not-found/page-not-found.component';
import { LiveMarketMapComponent } from './rental-menu/live-market-map/live-market-map.component';
import { CanDeactivateGuard } from './Shared/can-deactivate.guard';
import { VendorRegistrationRenewalComponent } from './rental-menu/vendor-registration-renewal/vendor-registration-renewal.component';

const routes: Routes = [
  {
    path: ':marketId',
    component: HomeComponent,
  },
  {
    path: 'home/:marketId',
    component: HomeComponent,
  },
  {
    path: 'registration/:marketId',
    component: VendorRegistrationComponent,
  },
  {
    path: 'registration/deactivated/:marketId',
    component: VendorRegistrationRenewalComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'menu/:marketId',
    component: RentalMenuComponent,
  },
  {
    path: 'login/:marketId',
    component: VendorLoginComponent,
  },
  {
    path: 'rent-online/rp',
    component: RentOnlineComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'rent-online/rp/:bookingpage/:rentaltype',
    component: RentOnlineComponent,
    canActivate: [AuthGuard]
  },
  {
    path:'newven-online/:marketId',
    component:NewVendorRentonlineComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'map/:marketId',
    component: MarketMapComponent,
  },
  {
    path: 'news/:marketId',
    component: NewsComponent,
  },
  {
    path: 'contact/:marketId',
    component: ContactUsComponent,
  },
  {
    path: 'vendor-payments/:marketId',
    component: VendorPaymentsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'vendor-payments/rp',
    component: VendorPaymentsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'thank-you/:marketId',
    component: RentalConfirmationComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'ven-app/:marketId',
    component: VendorApplicationComponent,
  },
  {
    path: 'pageNotFound/:marketId',
    component: PageNotFoundComponent,
  },
  {
    path: 'livemap/:marketId',
    component: LiveMarketMapComponent,
  },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
